// import React, { useRef, useState, useEffect, useCallback } from "react";
// import { FaCalendarAlt, FaInfoCircle, FaChair } from "react-icons/fa";
// import ReactPaginate from "react-paginate";
// import posterimage from "../assets/commingSoon.jpeg";
// import { API } from "../config/api";
// import { get } from "../lib/http";

// /* -------------------- Small helpers -------------------- */
// function downloadBlob(blob, filenameFallback = "file.bin") {
//   const url = URL.createObjectURL(blob);
//   const a = document.createElement("a");
//   a.href = url;
//   a.download = filenameFallback;
//   document.body.appendChild(a);
//   a.click();
//   a.remove();
//   URL.revokeObjectURL(url);
// }
// function b64toBlob(b64, type) {
//   const bin = atob(b64);
//   const arr = new Uint8Array(bin.length);
//   for (let i = 0; i < bin.length; i++) arr[i] = bin.charCodeAt(i);
//   return new Blob([arr], { type });
// }
// function formatBookingDate(iso) {
//   if (!iso) return "";
//   const d = new Date(iso);
//   return d
//     .toLocaleString("en-US", {
//       month: "short",
//       day: "2-digit",
//       year: "numeric",
//       hour: "2-digit",
//       minute: "2-digit",
//       hour12: true,
//     })
//     .replace(",", "");
// }
// function eventDateParts(iso) {
//   if (!iso) return { date: "", time: "" };
//   const d = new Date(iso);
//   const date = d.toLocaleDateString("en-US", {
//     weekday: "short",
//     day: "2-digit",
//     month: "short",
//     year: "numeric",
//   });
//   const time = d.toLocaleTimeString("en-US", {
//     hour: "2-digit",
//     minute: "2-digit",
//     hour12: true,
//   });
//   return { date, time };
// }
// async function waitForImages(node) {
//   const imgs = Array.from(node.querySelectorAll("img"));
//   if (!imgs.length) return;
//   await Promise.all(
//     imgs.map((img) => {
//       if (img.decode) return img.decode().catch(() => {});
//       if (img.complete && img.naturalWidth) return Promise.resolve();
//       return new Promise((res) => {
//         img.onload = img.onerror = () => res();
//       });
//     })
//   );
// }
// async function waitForFonts() {
//   if (document.fonts?.ready) {
//     try {
//       await document.fonts.ready;
//     } catch {}
//   }
// }
// const nextFrame = () =>
//   new Promise((r) => requestAnimationFrame(() => requestAnimationFrame(r)));

// /* ---------------------------------- Page ---------------------------------- */
// function TicketPage() {
//   const [tickets, setTickets] = useState([]);
//   const [printingId, setPrintingId] = useState(null);

//   // API-driven pagination
//   const [page, setPage] = useState(1); // 1-based for API
//   const [limit] = useState(15);
//   const [total, setTotal] = useState(0);
//   const [totalPages, setTotalPages] = useState(1);
//   const [loading, setLoading] = useState(false);
//   const [errMsg, setErrMsg] = useState("");

//   const fetchTickets = useCallback(async () => {
//     setLoading(true);
//     setErrMsg("");
//     try {
//       const raw = localStorage.getItem("bb_user");
//       const parsed = raw ? JSON.parse(raw) : null;
//       const token = parsed?.token ?? null;
//       const userId = parsed?.id ?? null;

//       if (!userId) {
//         setTickets([]);
//         setTotal(0);
//         setTotalPages(1);
//         setLoading(false);
//         setErrMsg("User not logged in.");
//         return;
//       }

//       const url = `${API.category.ticket}?userId=${encodeURIComponent(
//         userId
//       )}&page=${page}&limit=${limit}&paginate=true`;

//       const res = await get(url, {
//         headers: {
//           Authorization: token ? `Bearer ${token}` : undefined,
//           "Content-Type": "application/json",
//         },
//       });

//       // Expect: { paginate:true, meta:{ page, limit, total, totalPages }, data:[...] }
//       const arr = Array.isArray(res.data) ? res.data : [];
//       const meta = res?.meta || {};
//       const totalFromMeta = Number(meta.total) || 0;
//       const totalPagesFromMeta =
//         Number(meta.totalPages) || Math.max(1, Math.ceil(totalFromMeta / limit));
//       const pageFromMeta = Number(meta.page) || page;

//       setTickets(arr);
//       setTotal(totalFromMeta);
//       setTotalPages(totalPagesFromMeta);

//       if (pageFromMeta !== page) setPage(pageFromMeta);
//     } catch (e) {
//       console.error("fetchTickets error:", e);
//       setTickets([]);
//       setTotal(0);
//       setTotalPages(1);
//       setErrMsg(e?.message || "Failed to load Tickets.");
//     } finally {
//       setLoading(false);
//     }
//   }, [page, limit]);

//   useEffect(() => {
//     fetchTickets();
//   }, [fetchTickets]);

//   useEffect(() => {
//     const cleanup = () => setPrintingId(null);
//     window.addEventListener("afterprint", cleanup);
//     return () => window.removeEventListener("afterprint", cleanup);
//   }, []);

//   // react-paginate gives 0-based index
//   const handlePageChange = ({ selected }) => {
//     const newPage = selected + 1;
//     if (newPage !== page) setPage(newPage);
//   };

//   return (
//     <div className="min-h-screen flex flex-col bg-gray-50">
//       <style>{`
//         @media print {
//           @page { size: A4 portrait; margin: 12mm; }
//           body * { visibility: hidden !important; }
//           .print-area, .print-area * { visibility: visible !important; }
//           .print-area {
//             position: absolute; left: 0; top: 0; width: 100%;
//             box-shadow: none !important; border: none !important;
//             break-inside: avoid; page-break-inside: avoid;
//           }
//           .no-print { display: none !important; }
//         }
//       `}</style>

//       <main className="mt-32 md:mt-40 px-4 md:px-6 pb-10">
//         <div className="max-w-3xl mx-auto mb-3 bg-white border border-gray-200 rounded-xl p-3 flex items-center gap-3 shadow-sm">
//           <FaInfoCircle className="text-blue-600" />
//           <p className="text-sm md:text-base text-gray-800">
//             Access the M-Ticket(s) of your bookings on your smartphone
//           </p>
//         </div>

//         {errMsg && (
//           <div className="max-w-3xl mx-auto mb-3 bg-red-50 border border-red-200 text-red-700 rounded-xl p-3">
//             {errMsg}
//           </div>
//         )}

//         {loading && (
//           <div className="max-w-3xl mx-auto text-center text-gray-600 bg-white border rounded-xl p-6">
//             Loading tickets…
//           </div>
//         )}

//         {!loading &&
//           tickets.map((t) => (
//             <TicketCard
//               key={t._id}
//               ticket={t}
//               isPrinting={printingId === t._id}
//               onPrint={() => setPrintingId(t._id)}
//             />
//           ))}

//         {!loading && !tickets.length && !errMsg && (
//           <div className="max-w-3xl mx-auto text-center text-gray-600 bg-white border rounded-xl p-6">
//             No tickets found.
//           </div>
//         )}

//         {/* ReactPaginate controls */}
//         {!loading && totalPages > 1 && (
//           <div className="max-w-3xl mx-auto mt-6">
//             <ReactPaginate
//               breakLabel="..."
//               nextLabel="Next ›"
//               previousLabel="‹ Prev"
//               onPageChange={handlePageChange}
//               forcePage={Math.max(0, Math.min(totalPages - 1, page - 1))}
//               pageRangeDisplayed={5}
//               marginPagesDisplayed={1}
//               pageCount={totalPages}
//               containerClassName="flex items-center justify-center gap-2 select-none"
//               pageClassName="group"
//               pageLinkClassName="px-3 py-2 rounded border bg-white hover:bg-gray-50"
//               previousClassName="group"
//               previousLinkClassName="px-3 py-2 rounded border bg-white hover:bg-gray-50"
//               nextClassName="group"
//               nextLinkClassName="px-3 py-2 rounded border bg-white hover:bg-gray-50"
//               breakClassName="px-2"
//               activeClassName="!text-white"
//               activeLinkClassName="!bg-gray-900 !text-white"
//               disabledClassName="opacity-60 cursor-not-allowed"
//             />
//             {/* <div className="mt-2 text-center text-sm text-gray-600">
//               Page {page} of {totalPages} • {total} total
//             </div> */}
//           </div>
//         )}
//       </main>
//     </div>
//   );
// }

// /* -------------------- Card -------------------- */
// function TicketCard({ ticket, isPrinting, onPrint }) {
//   const captureRef = useRef(null);

//   const organizerName = ticket?.eventId?.organizer?.name || "";
//   const organizerLogo = ticket?.eventId?.organizer?.logoUrl || "";
//   const poster = ticket?.eventId?.imageUrl || posterimage;
//   const eventName = ticket?.eventId?.name || "";
//   const venueName = ticket?.eventId?.venue?.name || "";
//   const { date: eventDateStr, time: eventTimeStr } = eventDateParts(
//     ticket?.eventId?.date
//   );

//   const categories = Array.isArray(ticket?.ticketCategories)
//     ? ticket.ticketCategories
//     : [];
//   const categoryNames = categories
//     .map((c) =>
//       typeof c?.categoryId === "string"
//         ? c.categoryId
//         : c?.categoryId?.name || c?.categoryId?._id || ""
//     )
//     .filter(Boolean)
//     .join(", ");
//   const totalTickets = categories.reduce(
//     (sum, c) => sum + (Number(c.quantity) || 0),
//     0
//   );

//   const baseTicketAmount = Number(ticket?.bookingId?.totalAmount) || 0;
//   const discountAmount = Number(ticket?.discountValue) || 0;
//   const gstAmount = Number(ticket?.gstAmount) || 0;
//   const amountPaid = Number(ticket?.finalAmount) || 0;
//   const convenienceFee = Number(ticket?.convenienceFee) || 0;

//   const paymentMethod = ticket?.bookingId?.paymentId?.paymentMethod || "-";
//   const transactionId = ticket?.bookingId?.paymentId?.transactionId || "-";
//   const bookingCreatedAt = ticket?.bookingId?.paymentId?.createdAt || "";

//   const sponsors = Array.isArray(ticket?.eventId?.sponsors)
//     ? ticket.eventId.sponsors
//     : [];

//   const fileName = `${(eventName || "ticket")
//     .replace(/\s+/g, "-")
//     .slice(0, 50)}-${transactionId || ticket?._id || "download"}.png`;

//   const handleDownload = useCallback(async () => {
//     if (!captureRef.current) return;
//     const node = captureRef.current;

//     await waitForFonts();
//     await waitForImages(node);
//     await nextFrame();

//     const html2canvas = (await import("html2canvas")).default;
//     const canvas = await html2canvas(node, {
//       backgroundColor: null,
//       scale: 2,
//       useCORS: true,
//     });

//     let dataUrl;
//     try {
//       dataUrl = canvas.toDataURL("image/png");
//     } catch (e) {
//       alert(
//         "Some images are from a host without CORS. Ask the image host to allow CORS (Access-Control-Allow-Origin)."
//       );
//       return;
//     }

//     const link = document.createElement("a");
//     link.download = fileName;
//     link.href = dataUrl;
//     link.click();
//   }, [fileName]);

//   const handleDownloadPdfFromAPI = useCallback(async () => {
//     try {
//       const bookingCode = ticket?.bookingCode;
//       if (!bookingCode) {
//         alert("Booking code not found.");
//         return;
//       }

//       const token =
//         JSON.parse(localStorage.getItem("bb_user") || "{}")?.token ?? null;

//       const url = `http://20.41.122.214:5151/api/ticket/downloadTicketsAsPDF/${encodeURIComponent(
//         bookingCode
//       )}`;

//       const resp = await fetch(url, {
//         method: "POST",
//         headers: token ? { Authorization: `Bearer ${token}` } : {},
//       });

//       if (!resp.ok) {
//         const msg = await resp.text().catch(() => "");
//         throw new Error(`HTTP ${resp.status} ${msg}`);
//       }

//       const ct = (resp.headers.get("content-type") || "").toLowerCase();
//       let blob;

//       if (ct.includes("application/pdf")) {
//         blob = await resp.blob();
//       } else if (ct.includes("application/json")) {
//         const data = await resp.json().catch(() => ({}));
//         if (data?.pdfBase64) {
//           blob = b64toBlob(data.pdfBase64, "application/pdf");
//         } else if (data?.url) {
//           window.location.href = data.url;
//           return;
//         } else {
//           throw new Error("JSON received but no pdfBase64/url.");
//         }
//       } else {
//         blob = await resp.blob();
//       }

//       downloadBlob(blob, `${(eventName || "ticket").replace(/\s+/g, "-").slice(0, 50)}-${bookingCode}.pdf`);
//     } catch (err) {
//       console.error("PDF download error:", err);
//       alert(err?.message || "Could not download PDF. Please try again.");
//     }
//   }, [ticket, eventName]);

//   const handlePrint = () => {
//     onPrint?.();
//     setTimeout(() => window.print(), 50);
//   };

//   return (
//     <>
//       <div
//         ref={captureRef}
//         className={`max-w-5xl mx-auto bg-white rounded-2xl shadow-md border border-gray-200 overflow-hidden mb-4 ${
//           isPrinting ? "print-area" : ""
//         }`}
//       >
//         <div className="p-4 md:p-6 flex">
//           {/* Left Poster + Organizer */}
//           <div className="relative">
//             <div className="bg-gray-100 rounded-lg w-[150px] h-[220px] overflow-hidden">
//               <img
//                 src={poster}
//                 crossOrigin="anonymous"
//                 alt="Event Poster"
//                 className="w-[150px] h-[220px] object-fill"
//               />
//             </div>
//             {organizerLogo ? (
//               <div className="mt-8">
//                 <img
//                   src={organizerLogo}
//                   crossOrigin="anonymous"
//                   alt={organizerName || "Organizer"}
//                   className="h-32 w-32 rounded object-cover"
//                 />
//               </div>
//             ) : null}
//           </div>

//           {/* Vertical dashed separator */}
//           <div className="mx-4 md:mx-6 relative flex items-stretch">
//             <span className="pointer-events-none absolute -top-3 left-1/2 -translate-x-1/2 h-6 w-6 rounded-full bg-gray-50 border border-gray-200 shadow-inner mt-[-19px]" />
//             <div className="h-full w-[2px] border-l border-dashed border-gray-500 relative z-10" />
//             <span className="pointer-events-none absolute -bottom-3 left-1/2 -translate-x-1/2 h-6 w-6 rounded-full bg-gray-50 border border-gray-200 shadow-inner mb-[-19px]" />
//           </div>

//           {/* Right content */}
//           <div className="flex-1 min-w-0">
//             <div className="flex items-start justify-between gap-3">
//               <div className="min-w-0">
//                 <h2 className="text-base md:text-xl font-semibold text-gray-900 leading-tight md:leading-tight mb-2 break-words">
//                   {eventName}
//                 </h2>
//               </div>
//               <span className="text-xs px-2 py-1 rounded bg-gray-100 text-gray-700 border">
//                 M-Ticket
//               </span>
//             </div>

//             <div className="mt-1 text-sm text-gray-700">
//               <div className="flex items-center gap-2">
//                 <FaCalendarAlt className="text-purple-600" />
//                 <span>
//                   {eventDateStr} {" | "} {eventTimeStr}
//                 </span>
//               </div>
//               <div className="mt-1 text-gray-600">{venueName}</div>
//             </div>

//             <div className="mt-3 flex flex-col gap-1 text-sm text-gray-800">
//               <span>
//                 <span className="text-gray-600">Category :</span>{" "}
//                 {categoryNames || "-"}
//               </span>
//               <span className="inline-flex items-center gap-2 text-gray-800">
//                 <FaChair className="text-gray-700" />
//                 {categoryNames || "-"} : {totalTickets} ticket(s)
//               </span>
//               <span className="text-gray-600">{venueName}</span>
//             </div>

//             <div className="mt-4 border rounded-lg">
//               <div className="flex items-center justify-between px-3 py-2 border-b">
//                 <div className="text-gray-700">Ticket price</div>
//                 <div className="text-gray-900 font-medium">₹ {baseTicketAmount}</div>
//               </div>
//               <div className="flex items-start justify-between px-3 py-2 border-b">
//                 <div>
//                   <div className="text-gray-700">Convenience fees</div>
//                   <div className="text-xs text-gray-500">Incl. of Tax</div>
//                 </div>
//                 <div className="text-gray-900 font-medium">₹ {convenienceFee}</div>
//               </div>
//               <div className="flex items-start justify-between px-3 py-2 border-b">
//                 <div>
//                   <div className="text-gray-700">GST Amount</div>
//                 </div>
//                 <div className="text-gray-900 font-medium">₹ {gstAmount}</div>
//               </div>
//               <div className="flex items-start justify-between px-3 py-2 border-b">
//                 <div>
//                   <div className="text-gray-700">Discount</div>
//                 </div>
//                 <div className="text-gray-900 font-medium">-₹ {discountAmount}</div>
//               </div>
//               <div className="flex items-center justify-between px-3 py-2 bg-gray-50">
//                 <div className="text-gray-900 font-semibold">Amount Paid</div>
//                 <div className="text-gray-900 font-semibold">₹ {amountPaid}</div>
//               </div>
//             </div>

//             {Array.isArray(sponsors) && sponsors.length ? (
//               <div className="mt-4">
//                 <h4 className="text-sm font-semibold text-slate-700 mb-3">Sponsors</h4>
//                 <div className="flex flex-wrap gap-3">
//                   {sponsors.map((s, idx) => (
//                     <div
//                       key={`${s?.logo || "s"}-${idx}`}
//                       className="flex items-center gap-2 p-2 rounded border border-slate-200 bg-slate-50 select-none"
//                       title={s?.name || "Sponsor"}
//                     >
//                       <img
//                         src={s?.logo}
//                         crossOrigin="anonymous"
//                         alt={s?.name || `Sponsor ${idx + 1}`}
//                         className="h-10 w-10 rounded object-cover"
//                       />
//                     </div>
//                   ))}
//                 </div>
//               </div>
//             ) : null}
//           </div>
//         </div>
//       </div>

//       {/* ✅ Meta grid is CORRECTLY inside TicketCard (scope fix) */}
//       <div className="max-w-3xl mx-auto mb-8 grid grid-cols-1 md:grid-cols-3 gap-3 no-print">
//         <MetaItem label="BOOKING DATE & TIME" value={formatBookingDate(bookingCreatedAt)} />
//         <MetaItem label="PAYMENT METHOD" value={paymentMethod} />
//         <MetaItem label="BOOKING ID" value={transactionId} />
//       </div>

//       <div className="max-w-3xl mx-auto mb-12 flex items-center justify-end gap-3 no-print">
//         <button
//           onClick={handleDownloadPdfFromAPI}
//           className="px-4 py-2 bg-emerald-600 hover:bg-emerald-700 text-white font-medium rounded-lg shadow text-sm md:text-base"
//         >
//           Download PDF
//         </button>

//         <button
//           onClick={handlePrint}
//           className="px-4 py-2 bg-gray-800 hover:bg-black text-white font-medium rounded-lg shadow text-sm md:text-base"
//         >
//           Print Ticket
//         </button>
//       </div>
//     </>
//   );
// }

// function MetaItem({ label, value }) {
//   return (
//     <div className="bg-white rounded-xl shadow p-3 border border-gray-200">
//       <div className="text-xs md:text-sm font-semibold">{label}</div>
//       <div className="text-sm text-gray-700 mt-1">{value || "-"}</div>
//     </div>
//   );
// }

// export default TicketPage;

import React, { useRef, useState, useEffect, useCallback } from "react";
import QRCode from "qrcode";
import {
  FaCalendarAlt,
  FaInfoCircle,
  FaChair,
  FaDownload,
  FaMapMarkerAlt,
  FaTicketAlt,
  FaCreditCard,
} from "react-icons/fa";
import ReactPaginate from "react-paginate";
import posterimage from "../assets/commingSoon.jpeg";
import { API } from "../config/api";
import { get } from "../lib/http";
import { absMediaUrl } from "../api/events.js";

/* -------------------- Small helpers -------------------- */
const TZ = "Asia/Kolkata";

function downloadBlob(blob, filenameFallback = "file.bin") {
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = filenameFallback;
  document.body.appendChild(a);
  a.click();
  a.remove();
  URL.revokeObjectURL(url);
}
function b64toBlob(b64, type) {
  const bin = atob(b64);
  const arr = new Uint8Array(bin.length);
  for (let i = 0; i < bin.length; i++) arr[i] = bin.charCodeAt(i);
  return new Blob([arr], { type });
}

/**
 * Booking timestamp: show in IST for user-friendliness.
 */
function formatBookingDateIST(iso) {
  if (!iso) return "-";
  const d = new Date(iso);
  return new Intl.DateTimeFormat("en-IN", {
    day: "2-digit",
    month: "short",
    year: "numeric",
    hour: "2-digit",
    minute: "2-digit",
    hour12: true,
    timeZone: TZ,
  }).format(d);
}

/**
 * Event timestamp parts:
 * mode:
 *  - "preserveBackendWallTime": Date & Time in UTC (exact wall-time as stored, no rollover)
 *  - "localIST": Date & Time converted to Asia/Kolkata
 */
function formatDTParts(iso, { mode = "preserveBackendWallTime" } = {}) {
  if (!iso) return { date: "", time: "" };
  const d = new Date(iso);
  const timeZone = mode === "localIST" ? TZ : "UTC";

  const date = new Intl.DateTimeFormat("en-IN", {
    weekday: "short",
    day: "2-digit",
    month: "short",
    year: "numeric",
    timeZone,
  }).format(d);

  const time = new Intl.DateTimeFormat("en-IN", {
    hour: "2-digit",
    minute: "2-digit",
    hour12: true,
    timeZone,
  }).format(d);

  return { date, time };
}

async function waitForImages(node) {
  const imgs = Array.from(node.querySelectorAll("img"));
  if (!imgs.length) return;
  await Promise.all(
    imgs.map((img) => {
      if (img.decode) return img.decode().catch(() => {});
      if (img.complete && img.naturalWidth) return Promise.resolve();
      return new Promise((res) => {
        img.onload = img.onerror = () => res();
      });
    })
  );
}
async function waitForFonts() {
  if (document.fonts?.ready) {
    try {
      await document.fonts.ready;
    } catch {}
  }
}
const nextFrame = () =>
  new Promise((r) => requestAnimationFrame(() => requestAnimationFrame(r)));

function refId(ref) {
  if (!ref) return "";
  if (typeof ref === "string") return ref;
  return ref._id != null ? String(ref._id) : "";
}

/** QR for gate scan — matches backend `generateTicketQR` payload shape. */
function TicketStubQrImage({ ticket, size = 112 }) {
  const [src, setSrc] = useState(() =>
    ticket?.qrCode && String(ticket.qrCode).startsWith("data:image") ? ticket.qrCode : ""
  );

  useEffect(() => {
    if (ticket?.qrCode && String(ticket.qrCode).startsWith("data:image")) {
      setSrc(ticket.qrCode);
      return undefined;
    }
    let cancelled = false;
    const payload = {
      ticketId: ticket?.ticketId,
      userId: refId(ticket?.userId),
      eventId: refId(ticket?.eventId),
      ticketCategories: ticket?.ticketCategories || [],
      bookingId: refId(ticket?.bookingId),
      issuedAt: ticket?.issuedAt,
      expiresAt: ticket?.expiresAt,
      status: ticket?.status,
      paymentStatus: ticket?.paymentStatus,
      transferHistory: ticket?.transferHistory || [],
    };
    QRCode.toDataURL(JSON.stringify(payload), {
      width: Math.max(160, size * 2),
      margin: 1,
      errorCorrectionLevel: "M",
    })
      .then((url) => {
        if (!cancelled) setSrc(url);
      })
      .catch(() => {
        if (!cancelled) setSrc("");
      });
    return () => {
      cancelled = true;
    };
  }, [ticket, size]);

  const box = { width: size, height: size };
  if (!src) {
    return (
      <div
        className="rounded-lg bg-white border border-slate-200 shadow-inner grid place-items-center text-slate-400 text-xs"
        style={box}
      >
        …
      </div>
    );
  }
  return (
    <img
      src={src}
      alt=""
      width={size}
      height={size}
      className="rounded-md bg-white p-1 border border-slate-200 shadow-sm object-contain"
      style={box}
    />
  );
}

/* ---------------------------------- Page ---------------------------------- */
function TicketPage() {
  const [tickets, setTickets] = useState([]);

  // API-driven pagination
  const [page, setPage] = useState(1); // 1-based for API
  const [limit] = useState(15);
  const [total, setTotal] = useState(0);
  const [totalPages, setTotalPages] = useState(1);
  const [loading, setLoading] = useState(false);
  const [errMsg, setErrMsg] = useState("");

  const fetchTickets = useCallback(async () => {
    setLoading(true);
    setErrMsg("");
    try {
      const raw = localStorage.getItem("bb_user");
      const parsed = raw ? JSON.parse(raw) : null;
      const token = parsed?.token ?? null;
      const userId = parsed?.id ?? null;

      if (!userId) {
        setTickets([]);
        setTotal(0);
        setTotalPages(1);
        setLoading(false);
        setErrMsg("User not logged in.");
        return;
      }

      const url = `${API.category.ticket}?userId=${encodeURIComponent(
        userId
      )}&page=${page}&limit=${limit}&paginate=true`;

      const res = await get(url, {
        headers: {
          Authorization: token ? `Bearer ${token}` : undefined,
          "Content-Type": "application/json",
        },
      });

      // Expect: { paginate:true, meta:{ page, limit, total, totalPages }, data:[...] }
      const arr = Array.isArray(res.data) ? res.data : [];
      const meta = res?.meta || {};
      const totalFromMeta = Number(meta.total) || 0;
      const totalPagesFromMeta =
        Number(meta.totalPages) || Math.max(1, Math.ceil(totalFromMeta / limit));
      const pageFromMeta = Number(meta.page) || page;

      setTickets(arr);
      setTotal(totalFromMeta);
      setTotalPages(totalPagesFromMeta);

      if (pageFromMeta !== page) setPage(pageFromMeta);
    } catch (e) {
      console.error("fetchTickets error:", e);
      setTickets([]);
      setTotal(0);
      setTotalPages(1);
      setErrMsg(e?.message || "Failed to load Tickets.");
    } finally {
      setLoading(false);
    }
  }, [page, limit]);

  useEffect(() => {
    fetchTickets();
  }, [fetchTickets]);

  // react-paginate gives 0-based index
  const handlePageChange = ({ selected }) => {
    const newPage = selected + 1;
    if (newPage !== page) setPage(newPage);
  };

  return (
    <div className="min-h-screen flex flex-col bg-[radial-gradient(ellipse_at_top,_var(--tw-gradient-stops))] from-amber-50 via-white to-yellow-50 dark:from-slate-950 dark:via-slate-900 dark:to-slate-950">
      <style>{`
        @media print {
          @page { size: A4 portrait; margin: 12mm; }
          body * { visibility: hidden !important; }
          .print-area, .print-area * { visibility: visible !important; }
          .print-area { position: absolute; left: 0; top: 0; width: 100%; box-shadow: none !important; border: none !important; break-inside: avoid; page-break-inside: avoid; }
          .no-print { display: none !important; }
        }
        .fade-in { animation: fadeIn .45s ease both; }
        @keyframes fadeIn { from { opacity:.0; transform: translateY(6px) } to { opacity:1; transform: translateY(0) } }
        .shimmer { background: linear-gradient(90deg,#eee 25%,#fff8db 37%,#eee 63%); background-size: 400% 100%; animation: shimmer 1.2s infinite; }
        @keyframes shimmer { 0% { background-position:-400px 0 } 100% { background-position:400px 0 } }
      `}</style>

      <header className="sticky top-0 z-10 border-b border-slate-200/80 dark:border-slate-800/80 bg-white/90 dark:bg-slate-950/90 backdrop-blur-md">
        <div className="max-w-3xl mx-auto px-3 sm:px-4 py-2.5 flex items-center justify-between gap-3">
          <div className="flex items-center gap-2 text-slate-800 dark:text-white min-w-0">
            <FaTicketAlt className="text-amber-600 shrink-0 text-base" />
            <span className="font-semibold text-sm sm:text-base truncate">My Tickets</span>
          </div>
          <div className="text-[11px] sm:text-xs text-slate-500 tabular-nums shrink-0">Total {total}</div>
        </div>
      </header>

      <main className="mt-4 md:mt-6 px-3 sm:px-4 pb-8 md:pb-10">
        <div className="max-w-3xl mx-auto mb-4 rounded-xl border border-slate-200/90 dark:border-slate-700/90 bg-white dark:bg-slate-900 px-3 py-2.5 sm:px-4 sm:py-3 flex items-start gap-2.5 shadow-sm fade-in">
          <FaInfoCircle className="text-amber-600 shrink-0 mt-0.5 text-sm" />
          <p className="text-xs sm:text-sm text-slate-600 dark:text-slate-300 leading-snug">
            Open M‑Tickets on your phone at the gate. Download PDF for offline backup.
          </p>
        </div>

        {errMsg && (
          <div className="max-w-3xl mx-auto mb-4 bg-rose-50 border border-rose-200 text-rose-800 rounded-xl p-3 sm:p-4 fade-in">
            <div className="flex items-start gap-3">
              <FaInfoCircle className="text-rose-500 mt-0.5 flex-shrink-0" />
              <p className="text-sm">{errMsg}</p>
            </div>
          </div>
        )}

        {/* Loading state */}
        {loading && (
          <div className="max-w-3xl mx-auto space-y-3">
            {Array.from({ length: 3 }).map((_, i) => (
              <TicketShimmer key={i} />
            ))}
          </div>
        )}

        {/* Tickets list */}
        {!loading && (
          <div className="max-w-3xl mx-auto space-y-4">
            {tickets.map((t, index) => (
              <div key={t._id} className={`fade-in`} style={{ animationDelay: `${index * 40}ms` }}>
                <TicketCard ticket={t} />
              </div>
            ))}
          </div>
        )}

        {!loading && !tickets.length && !errMsg && (
          <div className="max-w-3xl mx-auto text-center text-slate-600 dark:text-slate-400 bg-white dark:bg-slate-900 border border-slate-200 dark:border-slate-800 rounded-xl p-8 shadow-sm fade-in">
            <div className="text-4xl mb-3">🎫</div>
            <h3 className="text-base font-semibold mb-1 text-slate-900 dark:text-white">No Tickets yet</h3>
            <p className="text-xs sm:text-sm">Book an event — your M‑Ticket will appear here.</p>
          </div>
        )}

        {/* ReactPaginate controls */}
        {!loading && totalPages > 1 && (
          <div className="max-w-3xl mx-auto mt-6 fade-in">
            <ReactPaginate
              breakLabel="…"
              nextLabel={<span className="flex items-center gap-1"><span>Next</span><FaDownload className="text-xs rotate-180" /></span>}
              previousLabel={<span className="flex items-center gap-1"><FaDownload className="text-xs" /><span>Prev</span></span>}
              onPageChange={handlePageChange}
              forcePage={Math.max(0, Math.min(totalPages - 1, page - 1))}
              pageRangeDisplayed={5}
              marginPagesDisplayed={1}
              pageCount={totalPages}
              containerClassName="flex items-center justify-center gap-1 md:gap-2 select-none text-slate-700 dark:text-slate-300"
              pageClassName="group"
              pageLinkClassName="px-2.5 py-1.5 rounded-md border border-slate-200 dark:border-slate-700 bg-white dark:bg-slate-800 hover:bg-amber-50 dark:hover:bg-amber-900/30 hover:border-amber-200 transition-colors text-xs font-medium"
              previousClassName="group"
              previousLinkClassName="px-2.5 py-1.5 rounded-md border border-slate-200 dark:border-slate-700 bg-white dark:bg-slate-800 hover:bg-amber-50 dark:hover:bg-amber-900/30 hover:border-amber-200 transition-colors text-xs font-medium flex items-center gap-1"
              nextClassName="group"
              nextLinkClassName="px-2.5 py-1.5 rounded-md border border-slate-200 dark:border-slate-700 bg-white dark:bg-slate-800 hover:bg-amber-50 dark:hover:bg-amber-900/30 hover:border-amber-200 transition-colors text-xs font-medium flex items-center gap-1"
              breakClassName="px-2 text-xs"
              activeClassName="selected"
            />
            <style>{`.selected a{background:#f59e0b!important;color:#fff!important;border-color:#f59e0b!important}`}</style>
            <div className="mt-2 text-center text-[11px] text-slate-500">
              Page {page} of {totalPages} • {total} total Tickets
            </div>
          </div>
        )}
      </main>
    </div>
  );
}

/* -------------------- Card -------------------- */
function TicketCard({ ticket }) {
  const captureRef = useRef(null);

  const organizerName = ticket?.eventId?.organizer?.name || "";
  const organizerLogo = absMediaUrl(ticket?.eventId?.organizer?.logoUrl) || "";

  // Poster candidates: portrait imageUrl → landscape → generic image → local fallback.
  // Some events have a broken/empty imageUrl but a valid landscape banner, so we
  // cycle through candidates via onError instead of relying on a single field.
  const ev = ticket?.eventId || {};
  const landscape = Array.isArray(ev?.landsacpImage)
    ? ev.landsacpImage.find(Boolean)
    : ev?.landsacpImage;
  const posterCandidates = [
    absMediaUrl(ev?.imageUrl),
    absMediaUrl(landscape),
    absMediaUrl(ev?.image),
  ].filter(Boolean);
  const poster = posterCandidates[0] || posterimage;
  const eventName = ticket?.eventId?.name || "";
  const venueName = ticket?.eventId?.venue?.name || "";

  // 👇 Event date/time: preserve backend wall-time (no IST shift)
  const { date: eventDateStr, time: eventTimeStr } = formatDTParts(
    ticket?.eventId?.date,
    { mode: "preserveBackendWallTime" }
  );

  const categories = Array.isArray(ticket?.ticketCategories) ? ticket.ticketCategories : [];
  const categoryNames = categories
    .map((c) => (typeof c?.categoryId === "string" ? c.categoryId : c?.categoryId?.name || c?.categoryId?._id || ""))
    .filter(Boolean)
    .join(", ");
  const lineQty = (c) => {
    const n =
      Number(c?.finalQuantity ?? c?.quantity ?? c?.paidQuantity ?? c?.qty ?? 0) || 0;
    if (n > 0) return n;
    if (Array.isArray(c?.codes) && c.codes.length) return c.codes.length;
    return 0;
  };
  const totalTickets = categories.reduce((sum, c) => sum + lineQty(c), 0);

  const bookingCode = ticket?.bookingCode || 0;

  const paymentMethod = ticket?.bookingId?.paymentId?.paymentMethod || "-";
  const transactionId = ticket?.bookingId?.paymentId?.transactionId || "-";
  const bookingCreatedAt = ticket?.bookingId?.paymentId?.createdAt || "";

  const fileName = `${(eventName || "ticket")
    .replace(/\s+/g, "-")
    .slice(0, 50)}-${transactionId || ticket?._id || "download"}.png`;

  const handleDownload = useCallback(async () => {
    if (!captureRef.current) return;
    const node = captureRef.current;

    await waitForFonts();
    await waitForImages(node);
    await nextFrame();

    const html2canvas = (await import("html2canvas")).default;
    const canvas = await html2canvas(node, {
      backgroundColor: null,
      scale: 2,
      useCORS: true,
    });

    let dataUrl;
    try {
      dataUrl = canvas.toDataURL("image/png");
    } catch (e) {
      alert(
        "Some images are from a host without CORS. Ask the image host to allow CORS (Access-Control-Allow-Origin)."
      );
      return;
    }

    const link = document.createElement("a");
    link.download = fileName;
    link.href = dataUrl;
    link.click();
  }, [fileName]);

  const handleDownloadPdfFromAPI = useCallback(async () => {
    try {
      const bookingCode = ticket?.bookingCode;
      const newUrl = import.meta.env.VITE_API_BASE_URL;
      if (!bookingCode) {
        alert("Booking code not found.");
        return;
      }
      const token = JSON.parse(localStorage.getItem("bb_user") || "{}").token ?? null;
      const url = `${newUrl}/api/ticket/downloadTicketsAsPDF/${encodeURIComponent(
        bookingCode
      )}`;
      const resp = await fetch(url, {
        method: "POST",
        headers: token ? { Authorization: `Bearer ${token}` } : {},
      });
      if (!resp.ok) {
        const msg = await resp.text().catch(() => "");
        throw new Error(`HTTP ${resp.status} ${msg}`);
      }
      const ct = (resp.headers.get("content-type") || "").toLowerCase();
      let blob;
      if (ct.includes("application/pdf")) blob = await resp.blob();
      else if (ct.includes("application/json")) {
        const data = await resp.json().catch(() => ({}));
        if (data?.pdfBase64) blob = b64toBlob(data.pdfBase64, "application/pdf");
        else if (data?.url) {
          window.location.href = data.url;
          return;
        } else throw new Error("JSON received but no pdfBase64/url.");
      } else blob = await resp.blob();
      downloadBlob(
        blob,
        `${(eventName || "ticket").replace(/\s+/g, "-").slice(0, 50)}-${bookingCode}.pdf`
      );
    } catch (err) {
      console.error("PDF download error:", err);
      alert(err?.message || "Could not download PDF. Please try again.");
    }
  }, [ticket, eventName]);

  return (
    <>
      <div
        ref={captureRef}
        className="group max-w-3xl mx-auto bg-white dark:bg-slate-900 rounded-2xl shadow-lg shadow-slate-300/50 dark:shadow-black/50 border border-slate-200/90 dark:border-slate-800/90 overflow-hidden mb-4 transition-shadow hover:shadow-xl"
      >
        {/* Header — full width (site amber / orange) */}
        <div className="relative px-4 py-3 sm:px-5 sm:py-3.5 text-white overflow-hidden">
          <div className="absolute inset-0 bg-gradient-to-r from-amber-500 via-orange-500 to-amber-400" />
          <div
            className="absolute inset-0 opacity-[0.12]"
            style={{
              backgroundImage: "radial-gradient(circle at 1px 1px, white 1px, transparent 0)",
              backgroundSize: "14px 14px",
            }}
          />
          <div className="relative flex flex-col gap-2 sm:flex-row sm:items-start sm:justify-between gap-y-2">
            <div className="min-w-0 pr-2 sm:pr-28">
              <h1 className="text-base sm:text-lg font-bold leading-snug tracking-tight break-words">
                {eventName || "Event"}
              </h1>
              <div className="mt-1.5 flex flex-col sm:flex-row sm:flex-wrap gap-x-3 gap-y-1 text-[11px] sm:text-xs text-amber-50">
                <span className="inline-flex items-center gap-1.5">
                  <FaCalendarAlt className="opacity-80 shrink-0 text-[10px]" />
                  <span>
                    {eventDateStr} · {eventTimeStr}
                  </span>
                </span>
                <span className="inline-flex items-center gap-1.5 min-w-0">
                  <FaMapMarkerAlt className="opacity-80 shrink-0 text-[10px]" />
                  <span className="truncate">{venueName || "—"}</span>
                </span>
              </div>
            </div>
            <div className="flex flex-wrap items-center gap-1.5 sm:absolute sm:right-4 sm:top-3 sm:flex-col sm:items-end">
              <span className="inline-flex items-center rounded-md border border-white/25 bg-white/10 px-2 py-0.5 text-[10px] font-semibold uppercase tracking-wide text-white/95">
                M‑Ticket
              </span>
              <span className="inline-flex items-center rounded-md bg-emerald-400/95 px-2 py-0.5 text-[10px] font-bold text-emerald-950 shadow-sm">
                {ticket?.status === "Active" ? "CONFIRMED" : ticket?.status || "CONFIRMED"}
              </span>
            </div>
          </div>
        </div>

        {/* Body: main ticket (left) + perforated stub (right) */}
        <div className="flex flex-col sm:flex-row items-stretch">
          <div className="relative flex-1 min-w-0 bg-white dark:bg-slate-900 p-4 sm:p-5 flex items-center">
            {/* left punch-hole */}
            <span
              className="pointer-events-none hidden sm:block absolute left-0 top-1/2 z-[1] -translate-y-1/2 w-3 h-6 rounded-r-full bg-slate-50 dark:bg-slate-950 border-y border-r border-slate-200/90 dark:border-slate-800/90 shadow-[inset_2px_0_4px_rgba(0,0,0,0.03)] dark:shadow-[inset_2px_0_4px_rgba(255,255,255,0.02)]"
              aria-hidden
            />
            
            <div className="flex flex-col sm:flex-row gap-4 w-full items-center sm:items-start pl-2 sm:pl-3">
              <div className="relative w-28 h-28 sm:w-32 sm:h-32 shrink-0 rounded-xl overflow-hidden border border-slate-200/80 dark:border-slate-700 shadow-sm ring-1 ring-black/[0.02]">
                <img
                  src={poster}
                  alt=""
                  className="w-full h-full object-cover"
                  onError={(e) => {
                    const el = e.currentTarget;
                    const idx = Number(el.dataset.candidateIdx || 0);
                    const next = posterCandidates[idx + 1];
                    if (next) {
                      el.dataset.candidateIdx = String(idx + 1);
                      el.src = next;
                    } else if (el.src !== posterimage) {
                      el.src = posterimage;
                    }
                  }}
                />
              </div>

              <div className="flex flex-1 flex-col justify-center min-w-0 space-y-3 pt-1 w-full text-center sm:text-left">
                <div className="inline-flex max-w-full items-center justify-center sm:justify-start gap-2 rounded-lg border border-amber-200/80 bg-amber-50/60 px-3 py-1.5 text-[11px] sm:text-xs font-semibold text-amber-900 mx-auto sm:mx-0">
                  <FaChair className="shrink-0 opacity-70 text-amber-700" />
                  <span className="truncate">
                    {categoryNames || "General"} • {totalTickets}{" "}
                    {totalTickets === 1 ? "Ticket" : "Tickets"}
                  </span>
                </div>
                
                <div className="inline-flex max-w-full items-center justify-center sm:justify-start gap-2 rounded-lg border border-slate-200 dark:border-slate-700 bg-slate-50 dark:bg-slate-800/50 px-3 py-1.5 text-[10px] sm:text-[11px] font-mono text-slate-600 dark:text-slate-300 mx-auto sm:mx-0">
                  <FaCreditCard className="shrink-0 opacity-60" />
                  <span className="truncate" title={String(transactionId)}>
                    TXN: {transactionId}
                  </span>
                </div>

                {organizerLogo ? (
                  <div className="flex items-center justify-center sm:justify-start gap-2 mt-1">
                    <img
                      src={organizerLogo}
                      alt=""
                      className="h-6 w-6 rounded-full object-cover border border-slate-200 shadow-sm"
                    />
                    <p className="text-xs text-slate-500 font-medium truncate">{organizerName}</p>
                  </div>
                ) : null}
              </div>
            </div>
          </div>

          {/* Perforated Divider (visual only, for desktop) */}
          <div className="hidden sm:flex flex-col items-center justify-center relative w-px bg-white dark:bg-slate-900">
            <div className="absolute inset-y-0 w-px border-l-2 border-dashed border-slate-200 dark:border-slate-700 z-10" />
          </div>

          {/* Stub: dashed perforation + QR (classic ticket) */}
          <aside className="relative flex flex-col items-center justify-center bg-slate-50/50 dark:bg-slate-800/30 p-4 sm:w-[150px] md:w-[170px] shrink-0 border-t sm:border-t-0 border-dashed border-slate-200 dark:border-slate-700">
            <span className="pointer-events-none hidden sm:block absolute -top-3 left-0 z-[1] -translate-x-1/2 w-6 h-6 rounded-full bg-slate-50 dark:bg-slate-950 border border-slate-200/90 dark:border-slate-800/90 shadow-inner" aria-hidden />
            <span className="pointer-events-none hidden sm:block absolute -bottom-3 left-0 z-[1] -translate-x-1/2 w-6 h-6 rounded-full bg-slate-50 dark:bg-slate-950 border border-slate-200/90 dark:border-slate-800/90 shadow-inner" aria-hidden />

            <div className="text-[10px] font-bold uppercase tracking-widest text-slate-400 dark:text-slate-500 mb-2">Scan QR</div>
            <TicketStubQrImage ticket={ticket} size={112} />
            <div className="text-[10px] font-mono text-slate-500 dark:text-slate-400 text-center truncate max-w-full mt-2" title={ticket?.ticketId}>
              {ticket?.ticketId || "—"}
            </div>
            <div className="text-[9px] text-center text-slate-400 mt-1">Present at entry</div>
          </aside>
        </div>

        {/* Footer meta + CTA */}
        <div className="border-t border-slate-200 dark:border-slate-800 bg-slate-50 dark:bg-slate-900/50">
          <div className="flex flex-col gap-3 p-3 sm:px-5 sm:py-3.5 sm:flex-row sm:items-center sm:justify-between">
            <div className="grid grid-cols-3 gap-3 sm:flex sm:flex-row sm:gap-8 sm:flex-1 sm:min-w-0">
              <MetaItem
                label="Booked On"
                value={formatBookingDateIST(bookingCreatedAt)}
              />
              <MetaItem
                label="Payment"
                value={paymentMethod}
              />
              <MetaItem
                label="Booking ID"
                value={bookingCode}
              />
            </div>
            <button
              type="button"
              onClick={handleDownloadPdfFromAPI}
              className="inline-flex w-full sm:w-auto shrink-0 items-center justify-center gap-2 rounded-xl bg-gradient-to-b from-amber-400 to-amber-500 hover:from-amber-500 hover:to-amber-600 px-4 py-2 text-xs sm:text-sm font-bold text-amber-950 shadow-sm transition-all focus:ring-2 focus:ring-amber-400 focus:ring-offset-2 border border-amber-500/50"
            >
              <FaDownload className="text-[11px] sm:text-xs opacity-80" />
              Download PDF
            </button>
          </div>
        </div>
      </div>
    </>
  );
}

function MetaItem({ label, value }) {
  return (
    <div className="flex flex-col min-w-0">
      <div className="text-[9px] sm:text-[10px] font-bold text-slate-400 dark:text-slate-500 uppercase tracking-wider mb-0.5">{label}</div>
      <div className="text-[11px] sm:text-xs text-slate-800 dark:text-slate-200 font-semibold truncate" title={String(value)}>{value ?? "-"}</div>
    </div>
  );
}

function TicketShimmer() {
  return (
    <div className="max-w-3xl mx-auto bg-white dark:bg-slate-900 rounded-xl shadow-sm border border-slate-200/90 dark:border-slate-800 overflow-hidden">
      <div className="h-10 shimmer dark:opacity-20" />
      <div className="p-3 flex gap-3">
        <div className="h-[7.25rem] w-[5.5rem] rounded-lg shrink-0 shimmer dark:opacity-20" />
        <div className="flex-1 space-y-2 min-w-0">
          <div className="h-6 w-[72%] rounded shimmer dark:opacity-20" />
          <div className="h-4 w-1/2 rounded shimmer dark:opacity-20" />
          <div className="h-20 rounded-lg shimmer dark:opacity-20" />
        </div>
      </div>
      <div className="h-14 border-t border-slate-100 dark:border-slate-800 shimmer dark:opacity-20" />
    </div>
  );
}

export default TicketPage;

